import { ManuteRequestConfig } from '@/api/types';

/**
 * Request to get current tenant info.
 */
export const TENANT_INFO = (): ManuteRequestConfig => ({
    method: 'GET',
    url: '/tenants/current',
    requiresAuth: false,
});
